import GlobalStyle from './styles/globalStyle';
import 'src/styles/resetCss';
import { RouterProvider } from 'react-router';
import { router } from 'src/router';
import Loading from 'src/components/common/Loading';
import { LoadingState } from 'src/recoil/ui';
import { useRecoilValue } from 'recoil';
import { useUserAgent } from 'src/hooks/useUserAgent';
import { useEffect } from 'react';

declare global {
    interface Window {
        phone_number: string;
    }
}

const App = () => {
  const isLoading = useRecoilValue(LoadingState);
  const { handleUserAgent } = useUserAgent();

  useEffect(() => {
    handleUserAgent();
  }, [handleUserAgent]);

  return (
    <>
      <GlobalStyle />
      {isLoading && <Loading />}
      <RouterProvider router={router} />
    </>
  );
};

export default App;
